
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-0a7d57a7&scoped=true!less-loader?sourceMap!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./wxBindForgetPass.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./wxBindForgetPass.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-0a7d57a7!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./wxBindForgetPass.vue"),
  /* scopeId */
  "data-v-0a7d57a7",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/user/NonVerified/wxBindForgetPass.vue
// module id = 1371
// module chunks = 18